import type { InjectionKey, Ref } from 'vue'

export type EditorCheckout = {
  checkout: () => Promise<unknown>
  disabled: Readonly<Ref<boolean>>
  loading: Readonly<Ref<boolean>>
}

// provided by the merged lottery page, which owns the checkout modals the editor may not import
export const EDITOR_CHECKOUT_KEY: InjectionKey<EditorCheckout> = Symbol('editorCheckout')

export const EDITOR_CUTOFF_MODAL_SILENCE_WINDOW_MS = 3_000
export const EDITOR_CUTOFF_REACHED_TOLERANCE_MS = 30_000

export const EDITOR_LOTTERY_HEADER_HEIGHT = '8rem'
export const EDITOR_LOTTERY_SCROLL_GAP = 8
export const EDITOR_LOTTERY_HEADER_HEIGHT_FALLBACK = 128

export const EDITOR_CONTROL_PANEL_BAR_ID = 'editor-control-panel'

export const EDITOR_PLAY_ID_ATTRIBUTE = 'data-editor-play-id'

export const EDITOR_COLLAPSING_BODY_SELECTOR = '[data-collapse="collapsing"]'

export const EDITOR_EXPANDED_PLAY_BODY_SELECTOR =
  '.lc-lottery-editor-card.lc-card--expanded > .lc-card__body-wrap'

export const EDITOR_CONTROL_PANEL_ACTION_ID = {
  AddLine: 'add-line',
  QuickPick: 'quick-pick',
} as const

export const EDITOR_QUICK_PICK_ACTION_ID_PREFIX = `${EDITOR_CONTROL_PANEL_ACTION_ID.QuickPick}-`

export const EDITOR_QUICK_PICK_MIN_QUANTITY = 1

export const EDITOR_QUERY_QUICK_PICK = 'quickpick'

export const EDITOR_QUERY_QUICK_PICK_BET_TYPE = 'quickpick_bet_type'

export const EDITOR_QUERY_QUICK_PICK_NUMBERS = 'quickpick_numbers'

export const EDITOR_QUERY_QUICK_PICK_WAGER = 'quickpick_wager'

export const EDITOR_QUICK_PICK_QUERY_PARAMS = [
  EDITOR_QUERY_QUICK_PICK,
  EDITOR_QUERY_QUICK_PICK_BET_TYPE,
  EDITOR_QUERY_QUICK_PICK_NUMBERS,
  EDITOR_QUERY_QUICK_PICK_WAGER,
]

export const EDITOR_UNDO_DURATION = 2800

export const EDITOR_PLAY_SLIDE_DURATION = 250

export const EDITOR_SCROLL_IDLE_DELAY_MS = 200

export const EDITOR_SCROLL_IDLE_TIMEOUT_MS = 1500

export const EDITOR_COLLAPSE_TIMEOUT_MS = 1_000

// above the backdrop of any modal, see `.lc-modal__bg`
export const EDITOR_SPOTLIGHT_Z_INDEX = 2011

export const EDITOR_REVIEW_MODAL_GAP_PX = 16

// matches $transition-duration-md, the fade in of every modal
export const EDITOR_REVIEW_MODAL_FADE_MS = 300

// estimated height of the review modal, it is only measurable once open and the page is locked
export const EDITOR_REVIEW_MODAL_SPACE_PX = EDITOR_REVIEW_MODAL_GAP_PX + 280
